import MainHeader from "./MainHeader";
import TopBanner from "./TopBanner";
export default function Header() {
  return (
    <>
      <MainHeader />
      <TopBanner />
    </>
  );
}
